<template>
	<card layout="grid" tag="section">
		<template #default>
			<loading v-if="loading"></loading>
			<div v-else class="widget-container">
				<div class="partner-info" v-for="(g, i) in groups" :key="i">
					<div>
						<user-picture
							size="large"
							:uuid="g.uuid"
							field="TileImage"
							:user="{ FirstName: g.name, LastName: 'Practice' }"></user-picture>
						<div class="is-flex is-flex-direction-column mt-2">
							<div>
								<h3>{{ g.name }}</h3>
							</div>
							<div class="mt-4">
								<div>
									<span class="has-text-grey">Total billings:&nbsp;</span>
									<strong>{{ currencyFormat.format(g.totalBillingsUsd) }}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <o-button outlined>View full list</o-button> -->
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import { currencyFormat } from "@/services/utils";
	export default {
		props: {
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			const $http = inject("$http");
			const $error = inject("$error");

			const groups = ref([]);

			const loading = ref(true);

			const GetData = async () => {
				try {
					loading.value = true;
					const response = await $http.post("/api/v2/widget/topPracticeGroups", {
						filter: props.filters
					});
					groups.value = response.data;
					loading.value = false;
				} catch (err) {
					$error("Could not retrieve practice groups.");
					loading.value = false;
				}
			};

			onMounted(() => {
				GetData();
			});

			return {
				currencyFormat,
				groups,
				loading
			};
		}
	};
</script>
